import { render, staticRenderFns } from "./detailInstantClaim.vue?vue&type=template&id=06f445ca&scoped=true&"
import script from "./detailInstantClaim.vue?vue&type=script&lang=js&"
export * from "./detailInstantClaim.vue?vue&type=script&lang=js&"
import style0 from "./detailInstantClaim.vue?vue&type=style&index=0&id=06f445ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f445ca",
  null
  
)

export default component.exports